module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.f619578e.mp3";